import { css, keyframes } from 'styled-components';

// Fade in animation
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// Slide up animation
export const slideUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

// Scale X animation
export const scaleX = keyframes`
  from {
    transform: scaleX(0);
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    opacity: 1;
  }
`;

// Scale Y animation
export const scaleY = keyframes`
  from {
    transform: scaleY(0);
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
`;

// Slide down animation
export const slideDown = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

// Slide in from left
export const slideInLeft = keyframes`
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

// Slide in from right
export const slideInRight = keyframes`
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

// Scale up animation
export const scaleUp = keyframes`
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

// Animation presets
export const animationPresets = {
  fadeIn: css`
    animation: ${fadeIn} 0.375s ease-out forwards;
  `,
  slideDown: css`
    animation: ${slideDown} 0.375s ease-out forwards;
  `,
  slideUp: css`
    animation: ${slideUp} 0.375s ease-out forwards;
  `,
  slideInLeft: css`
    animation: ${slideInLeft} 0.375s ease-out forwards;
  `,
  slideInRight: css`
    animation: ${slideInRight} 0.375s ease-out forwards;
  `,
  scaleUp: css`
    animation: ${scaleUp} 0.375s ease-out forwards;
  `,
  scaleX: css`
    animation: ${scaleX} 0.375s ease-out forwards;
  `,
  scaleY: css`
    animation: ${scaleY} 0.375s ease-out forwards;
  `,
};

// Utility function to create animation with delay
export const createAnimation = (preset: keyof typeof animationPresets, delay = 0) => css`
  opacity: 0;
  ${animationPresets[preset]}
  animation-delay: ${delay}s;
`;
